module.exports = __webpack_public_path__ + "static/media/settings.29be0699.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/settings.svg
// module id = 568
// module chunks = 53